import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './BildiriGonderimi.css';

function BildiriGonderimi() {
  const formLink = "https://docs.google.com/forms/d/e/1FAIpQLSdaLPVcHl7IEVtgKR0DbQ0Qe3Oj9uxZI79FvCtsNAadgsS3AA/viewform";

  return (
    <div className="bildiri-gonderim-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>BİLDİRİ GÖNDERİMİ</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container">
        <div className="deadline-banner">
          <h3>SON GÖNDERİM TARİHİ</h3>
          <div className="date-badge">15 NİSAN 2026 ÇARŞAMBA - 23.59</div>
        </div>

        <div className="info-grid">
          <section className="rules-card">
            <h3>Başvuru Koşulları</h3>
            <p>Bildiri metinlerinizin yazım kurallarına uygun olarak düzenlenmiş olması büyük önem taşımaktadır!</p>
            <ul>
              <li>Bildirilerin, <strong>genişletilmiş bildiri</strong> yazım kurallarına ve şablonuna tam olarak uyması gerekmektedir.</li>
              <li>Şekil şartları bakımından uygun olmayan bildirilerin değerlendirme sürecine alınması mümkün değildir.</li>
              <li>Uygun olmayan bildiriler, gerekli düzenlemeleri yapmaları ricasıyla yazarlara iade edilecektir.</li>
              <li>Başvuru formu üzerinden yükleme yaparken dosyanın <strong>Word belgesi</strong> formatında olduğundan emin olunuz.</li>
            </ul>
          </section>

          <section className="action-card">
            <div className="submit-section">
              <h4>Bildiri Başvuru Sistemi</h4>
              <p>Bildirinizi sisteme yüklemek ve kayıt işlemlerinizi başlatmak için aşağıdaki butona tıklayarak başvuru formunu doldurunuz.</p>
              
              <a 
                href={formLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="submit-button"
              >
                BİLDİRİ GÖNDER / KAYIT OL <i className="fas fa-paper-plane" style={{marginLeft: '10px'}}></i>
              </a>
              
              <p className="sub-info-text">
                * Bu form hem bildiri gönderimi hem de genel kayıt işlemleri için kullanılmaktadır.
              </p>
            </div>

            <div className="feedback-alert">
              <p>Formu doldurduktan sonra herhangi bir sorun yaşarsanız veya teyit almak isterseniz <strong>yonorg2026@gmail.com</strong> üzerinden bize ulaşabilirsiniz.</p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default BildiriGonderimi;